import { ReactElement } from 'react';

const TwitterIcon = (props: TClassNameProps): ReactElement => (
	<svg width="16" height="17" viewBox="0 0 16 17" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.0078 0.398438H13.625L8.61719 6.21875L4.60938 0.398438H0L6.01562 9.19531L0.0078125 16.2266H1.36719L6.64844 10.0859L10.8828 16.2266H15.4844L9.20312 7.11719L15.0078 0.398438ZM1.85791 1.42474H3.93799L13.6297 15.2535H11.5192L1.85791 1.42474Z"
			fill="currentColor"
		/>
	</svg>
);

export default TwitterIcon;
